import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'

const AdxBeta = () => {
  return (
    <AdxStatusBar
      status={{
        text: 'Beta',
        color: 'alternate.main',
        bgColor: 'alternate.light',
      }}
    />
  )
}

export default AdxBeta
